/**
 * Checks whether the specified number is within the given range.
 *
 * @param number- The number to test.
 * @param range - 2-tuple specifying the minimum and maximum bounds of the
 * number.
 *
 * @returns Whether the number fits the given range.
 */
export function withinRange(number: number, range: [number, number]): boolean {
  return range[0] <= number && number <= range[1];
}

/**
 * Checks whether the two given numbers are equal to a tolerance eps.
 *
 * @param x - The first number.
 * @param y - The second number.
 * @param eps - The maximum allowable tolerance.
 *
 * @returns Whether the two numbers are equal to the specified tolernace.
 */
export function equalWithEps(x: number, y: number, eps: number): boolean {
  return withinRange(x, [y - eps, y + eps]);
}

/**
 * Performs a mathematically formal modulo with support for negative numbers.
 * @see https://web.archive.org/web/20090717035140if_/javascript.about.com/od/problemsolving/a/modulobug.htm
 */
export function mod(dividend: number, divisor: number): number {
  return ((dividend % divisor) + divisor) % divisor;
}
